/**
 * Kiosk payment method enum — kept in its own leaf module (no imports back into
 * the kiosk/ticketing barrels) so cross-folder contracts can reference it
 * without creating a circular import. In particular, ticketing's
 * `kiosk-inter-service.ts` imports this directly instead of the `../kiosk`
 * barrel, which would otherwise load `wristband-identity.ts` (which imports back
 * from `kiosk-inter-service.ts`) before its schemas finish initializing.
 */

import { z } from 'zod';

export const KioskPaymentMethodSchema = z.enum(['QRIS', 'EDC', 'CASH']);
export type KioskPaymentMethod = z.infer<typeof KioskPaymentMethodSchema>;
